import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // ── Stat cards ──────────────────────────────────────────────────────────
  statCard: {
    display: 'flex',
    overflow: 'hidden',
    height: '100%',
    minHeight: 88,
  },
  statCardIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 72,
    minWidth: 72,
    color: theme.palette.white,
  },
  statCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  statCardValue: {
    fontWeight: 700,
    lineHeight: 1.1,
    color: theme.palette.black,
  },
  statCardLabel: {
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(0.5),
    letterSpacing: '0.04em',
  },

  // ── Charts ──────────────────────────────────────────────────────────────
  chartPaper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chartHeader: {
    padding: theme.spacing(2, 2, 0),
  },
  chartTitle: {
    fontWeight: 600,
    color: theme.palette.black,
  },
  chartSubtitle: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(0.25),
  },

  // ── Donut section ───────────────────────────────────────────────────────
  sectionPaper: {
    height: '100%',
    padding: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.black,
    marginBottom: theme.spacing(0.5),
  },

  // ── Risk table ──────────────────────────────────────────────────────────
  tableHeader: {
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  departmentName: {
    fontWeight: 600,
    color: theme.palette.black,
  },
  chipLow: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.white,
    fontWeight: 700,
    height: 21,
  },
  chipMedium: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.white,
    fontWeight: 700,
    height: 21,
  },
  chipHigh: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.white,
    fontWeight: 700,
    height: 21,
  },
  iconCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  toolIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  },
  toolName: {
    color: theme.palette.text.primary,
  },
  toolList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.5, 0),
  },
  emptyCell: {
    color: theme.palette.text.disabled,
  },
}))

export default useStyles
